"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework base class for DataFilter controls
         * @internal
         */
        var DataFilter = /** @class */ (function (_super) {
            __extends(DataFilter, _super);
            function DataFilter(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                $dyn.setValue(_this, "Visible", false);
                var root = _this.Root;
                if (root) {
                    var part_1 = $dyn.value(root.Part);
                    if (part_1) {
                        var currentChanges_1 = $dyn.computed(function () {
                            var isDataBound = _this.IsDataBound();
                            var changes = [];
                            if (isDataBound) {
                                var children_1 = _this.Children();
                                var links = part_1.Children();
                                for (var i = 0, len = children_1.length; i < len; i++) {
                                    var filterRange = children_1[i];
                                    for (var linkIndex = 0, linksLength = links.length; linkIndex < linksLength; linkIndex++) {
                                        var link = links[linkIndex];
                                        if (link.Name === $dyn.value(filterRange.LinkedId)) {
                                            filterRange.Link = link;
                                            var linkedValue = $dyn.value(link.LinkedValue);
                                            var rangeValue = $dyn.value(filterRange.RangeValue);
                                            if (rangeValue !== linkedValue) {
                                                changes.push({ range: filterRange, value: linkedValue });
                                            }
                                        }
                                    }
                                }
                            }
                            return changes;
                        });
                        var expansionChanged = function (partExpanded) {
                            partExpanded = $dyn.value(partExpanded);
                            // Update expanded part only if scheduled.
                            if (partExpanded === true && _this.applyChangeScheduled === true) {
                                _this.applyChangeScheduled = false;
                                dataFilterChanged_1(currentChanges_1());
                            }
                        };
                        var applyChanges_1 = function (_changes) {
                            for (var i = 0, len = _changes.length; i < len; i++) {
                                var change = _changes[i];
                                $dyn.setValue(change.range, "RangeValue", change.value);
                            }
                            $dyn.applyFunction(_this.ApplyChanges, _this);
                            _this.applyChangeScheduled = false;
                        };
                        var dataFilterChanged_1 = function (changes) {
                            changes = $dyn.value(changes);
                            if (changes.length > 0) {
                                if (root.Expanded && !$dyn.value(root.Expanded)) {
                                    // Scheduling update for later when the factbox will be expanded.
                                    _this.applyChangeScheduled = true;
                                }
                                else if (!_this.applyChangeScheduled) {
                                    // No applyChanges has been secheduled yet
                                    // Schedule a call to applyChanges with any currentChanges once the clint is done processing.
                                    _this.applyChangeScheduled = true;
                                    $dyn.async(function () {
                                        applyChanges_1(currentChanges_1());
                                    }, undefined, "Defer setting of rangeValue changes so we can batch them all from the same event loop");
                                }
                                else {
                                    // There is a scheduled applyChanges call.
                                    // Ignore changes as they will be included when the deferred applyChanges triggers
                                }
                            }
                        };
                        currentChanges_1.valueChanged.subscribe(dataFilterChanged_1);
                        dataFilterChanged_1(currentChanges_1());
                        if (root.Expanded) {
                            _this.expandedSubscription = root.Expanded.valueChanged.subscribe(expansionChanged);
                            expansionChanged(root.Expanded);
                        }
                    }
                }
                return _this;
            }
            DataFilter.prototype.dispose = function () {
                if (this.expandedSubscription && this.Root) {
                    this.Root.Expanded.valueChanged.unsubscribe(this.expandedSubscription);
                }
                _super.prototype.dispose.call(this);
            };
            return DataFilter;
        }($dyn.ui.Container));
        controls.DataFilter = DataFilter;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DataFilter.js.map
